import { useState, useEffect, useRef } from "react";
import { Wrapper, PanelContext } from "nystem-components";
import app from "nystem";

const types = {
  default: {
    wrapper: "my-2 border shadow rounded border-gray-700",
    body: "px-3",
    header: "bg-gray-800 pointer p-1 pl-3",
  },
  primary: {
    wrapper: "my-2 border shadow rounded bg-blue-600 border-blue-600",
    body: "px-3 py-1 bg-white rounded",
    header: "text-white pointer p-1 pl-3",
  },
  compact: {
    wrapper: "mb-1",
    body: "pl-3",
    header: "",
  },
};

const Panel = ({ body, header, className, ...props }) => {
  const [expanded, setSexpanded] = useState(props.expanded);
  const panelElement = useRef(null);

  const toggleExpand = () => {
    setSexpanded(!expanded);
    app().stateStore.set(panelElement, !expanded, props.stateStore);
  };

  useEffect(() => {
    const storedState = app().stateStore.get(panelElement, props.stateStore);
    if (storedState === null || storedState === expanded) return;
    setSexpanded(storedState);
  }, [expanded, props.stateStore]);

  const type = types[props.type || "default"] || types.default;

  return (
    <Wrapper ref={panelElement} className={[type.wrapper, className]}>
      <Wrapper className={type.header}>
        <PanelContext.Provider value={{ toggleExpand, expanded }}>
          {header}
        </PanelContext.Provider>
      </Wrapper>
      {expanded ? (
        <Wrapper className={type.body}>{body}</Wrapper>
      ) : props.visibilityHidden ? (
        <Wrapper className={[type.body, "hidden"]}>{body}</Wrapper>
      ) : null}
    </Wrapper>
  );
};

export default Panel;
